const NorthwesternEducation = (
  <p>
    <h2>Northwestern University</h2>
    <h3>Doctor of Philosophy (Ph.D.), Materials Science and Engineering</h3>
    <h3>2015-2020</h3>
    <h5>
      Thesis: "Probing static and dynamic phenomena in two-dimensionally
      confined systems"
    </h5>
    <h5>Advisor: Professor Vinayak P. Dravid</h5>
    <ul className="educationBullets">
      <li>
        Independently designed and directed several research initiatives aimed
        at addressing challenges within the 2D materials sub-field and published
        findings in multiple high-impact journals
      </li>
      <li>
        Successfully developed solutions for synthesizing highly sensitive,
        atomically thin, quantum materials with desired specifications using
        vapor deposition methods
      </li>
      <li>
        Optimized a variety of nanofabrication techniques and developed a new
        process flow for accurately assessing the properties of 2D
        semiconducting materials
      </li>
      <li>
        Formulated a creative method for combining electronic measurements with
        electron microscopy of 2D materials in order to gain fundamental
        insights related to the impact of structure on properties in next
        generation electronic devices
      </li>
      <li>
        Employed various bulk and surface characterization techniques in order
        to understand and improve the electronic and optical properties of
        nanoscale materials
      </li>
      <li>
        Collaborated with scientists internationally across 6 research groups
        within 4 disciplines to publish advances in the understanding of the
        catalytic, thermal, optical, and electronic properties of layered
        semiconductor systems
      </li>
    </ul>
  </p>
);
const UIUCEducation = (
  <p>
    <h2>University of Illinois at Urbana-Champaign</h2>
    <h3>Bachelor's Degree, Materials Science and Engineering</h3>
    <h3>2012-2015</h3>
  </p>
);
export { NorthwesternEducation, UIUCEducation };
